<script>
import MetisMenu from "metismenujs/dist/metismenujs";

export default {
  components: {},
  data() {
    return {
      user: {
        seller: {}
      }
    }
  },
  mounted: function() {
    this.$store.dispatch('USER_DATA').then((res) => {
      this.user = res;
    })

    document.body.setAttribute("data-sidebar", "light");
    document.body.setAttribute("data-topbar", "dark");
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu("#side-menu");
    var links = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("mm-active");
        const parent2 = parent.parentElement.closest("ul");
        if (parent2 && parent2.id !== "side-menu") {
          parent2.classList.add("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("mm-active");
            var childAnchor = parent3.querySelector(".has-arrow");
            var childDropdown = parent3.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4) parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            if (parent5) parent5.classList.add("mm-active");
          }
        }
      }
    }
  },
  methods: {
    lightSidebar() {
      document.body.setAttribute("data-topbar", "dark");
      document.body.removeAttribute("data-sidebar");
      document.body.removeAttribute("data-layout-size", "boxed");
      document.body.removeAttribute("data-sidebar-size", "small");
      document.body.classList.remove("vertical-collpsed");
    },
    compactSidebar() {
      document.body.setAttribute("data-sidebar-size", "small");
      document.body.setAttribute("data-sidebar", "dark");
      document.body.removeAttribute("data-layout-size", "boxed");
      document.body.classList.remove("vertical-collpsed");
      document.body.removeAttribute("data-topbar", "dark");
    },
    iconSidebar() {
      document.body.setAttribute("data-keep-enlarged", "true");
      document.body.classList.add("vertical-collpsed");
      document.body.setAttribute("data-sidebar", "dark");
      document.body.removeAttribute("data-topbar", "dark");
      document.body.removeAttribute("data-layout-size", "boxed");
    },
    boxedLayout() {
      document.body.setAttribute("data-keep-enlarged", "true");
      document.body.classList.add("vertical-collpsed");
      document.body.setAttribute("data-layout-size", "boxed");
      document.body.removeAttribute("data-sidebar", "colored");
      document.body.setAttribute("data-sidebar", "dark");
      document.body.removeAttribute("data-topbar", "dark");
    },
    coloredSidebar() {
      document.body.setAttribute("data-sidebar", "colored");
      document.body.removeAttribute("data-layout-size", "boxed");
      document.body.removeAttribute("data-sidebar-size", "small");
      document.body.classList.remove("vertical-collpsed");
    }
  }
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <li class="menu-title">Menu</li>

      <li>
        <router-link tag="a" to="/dashboard" class="side-nav-link-ref">
          <i class="bx bx-home-circle"></i>
          <span>Página Inicial</span>
        </router-link>
      </li>

      <!-- <li>
        <router-link tag="a" to="/customers" class="side-nav-link-ref">
          <i class="bx bx-briefcase"></i>
          <span>Clientes</span>
        </router-link>
      </li> -->

      <li v-if="!$store.getters.orderStarted">
        <router-link tag="a" to="/customers" class="side-nav-link-ref">
          <i class="bx bx-cart"></i>
          <span>Novo Pedido</span>
        </router-link>
      </li>

      <li v-if="$store.getters.orderStarted">
        <router-link tag="a" to="/products" class="side-nav-link-ref">
          <i class="bx bx-cart"></i>
          <span>Continuar Comprando</span>
        </router-link>
      </li>

      <li>
        <router-link tag="a" to="/activities" class="side-nav-link-ref">
          <i class="bx bx-task"></i>
          <span>Atividades</span>
        </router-link>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-user"></i>
          <span>Cadastro de Clientes</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li>
            <router-link tag="a" to="/new-customer" class="side-nav-link-ref">Novo Cliente</router-link>
          </li>
          <li>
            <router-link tag="a" to="/seller-customers" class="side-nav-link-ref">Acompanhamento</router-link>
          </li>
        </ul>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-printer"></i>
          <span>Relatórios</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li>
            <router-link tag="a" to="/reports/customers-list" class="side-nav-link-ref">Listagem de Clientes</router-link>
          </li>
          <li>
            <router-link tag="a" to="/reports/order-status" class="side-nav-link-ref">Pedidos em Orçamentos</router-link>
          </li>
          <li>
            <router-link tag="a" to="/reports/order-history" class="side-nav-link-ref">Histórico de Pedidos</router-link>
          </li>
          <li>
            <router-link tag="a" to="/reports/invoice-history" class="side-nav-link-ref">Histórico de Faturamento</router-link>
          </li>
          <li>
            <router-link tag="a" to="/reports/commissions" class="side-nav-link-ref">Histórico de Comissão</router-link>
          </li>
          <li>
            <router-link tag="a" to="/reports/abc-curve-customers" class="side-nav-link-ref">Curva ABC de Clientes</router-link>
          </li>
          <li>
            <router-link tag="a" to="/reports/abc-curve-products" class="side-nav-link-ref">Curva ABC de Produtos</router-link>
          </li>
          <li>
            <router-link tag="a" to="/reports/goals" class="side-nav-link-ref">Histórico de Metas</router-link>
          </li>
          <li>
            <router-link tag="a" to="/reports/products-stock" class="side-nav-link-ref">Listagem de Estoque</router-link>
          </li>
          <li v-show="user.user === 'administrador'">
            <router-link tag="a" to="/reports/products" class="side-nav-link-ref">Listagem de Produtos</router-link>
          </li>
          <li>
            <router-link tag="a" to="/reports/pendencies" class="side-nav-link-ref">Pendências Financeiras</router-link>
          </li>
        </ul>
      </li>

      <li v-show="user.seller.type === 'VO'">
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-user-voice"></i>
          <span>CRM</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li>
            <router-link tag="a" to="/select-customer-crm?action=crm" class="side-nav-link-ref">Inclusão</router-link>
          </li>

          <li>
            <a href="javascript: void(0);" class="has-arrow">
              <span>Relatórios</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
              <li>
                <router-link tag="a" to="/crm-open" class="side-nav-link-ref">Abertos</router-link>
              </li>
              <li>
                <router-link tag="a" to="/crm-closed" class="side-nav-link-ref">Fechados</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </li>

      <li v-if="!$store.getters.orderStarted">
        <router-link tag="a" to="/policy" class="side-nav-link-ref">
          <i class="bx bx-file"></i>
          <span>Política Comercial</span>
        </router-link>
      </li>

      <!-- <li>
        <router-link tag="a" to="/settings" class="side-nav-link-ref">
          <i class="bx bx-cog"></i>
          <span>Configurações</span>
        </router-link>
      </li> -->
    </ul>
  </div>
  <!-- Sidebar -->
</template>
